<phoenix-simple-table
  [dataSource]="activityLog"
  [tableConfig]="activityTableConfig"
  [loadingTable]="isLoadingActivityLogTable"
  [searchBoxPlaceholder]="searchBoxPlaceholder"
  class="mb-8"
  [pageIndex]="activityPageToken"
  [pageSize]="activityPageSize"
  [dataSourceLength]="activityDataSourceLength"
  (pageChange)="searchboxChange.emit($event)"
  (searchboxChange)="searchboxChange.emit($event)"
></phoenix-simple-table>

<ng-template #activityLogExpandable let-row="row">
  <div class="p-4 rounded-lg space-y-4 max-h-[400px] overflow-y-auto">
    @if (row.history.length > 0) {
      @for (change of row.history ?? []; track $index) {
        <div class="p-3 rounded-md theme-bg-2 shadow-md">
          <!-- Operation and Path -->
          <div class="flex items-center mb-2">
            <span
              class="text-xs uppercase font-bold px-2 py-1 rounded-md mr-2"
              [ngClass]="{
                'red-theme-bg-1': change.op === 'REMOVE',
                'blue-theme-bg-2': change.op === 'ADD',
                'yellow-theme-bg-1': change.op === 'REPLACE',
              }"
            >
              {{ change.op }}
            </span>
            <span class="text-sm italic">{{ change.path }}</span>
          </div>

          <!-- Change Details -->
          <div class="flex items-center space-x-2 text-sm overflow-x-auto">
            <!-- Old Value (if applicable) -->
            @if (
              change.old && (change.op === 'REPLACE' || change.op === 'REMOVE')
            ) {
              <div class="red-theme-bg-1 px-2 py-1 rounded">
                <pre>{{ change.old | json }}</pre>
              </div>
            }

            @if (change.op === 'REPLACE' && change.old) {
              <span>→</span>
            }

            @if (change.op === 'REPLACE' || change.op === 'ADD') {
              <div class="green-theme-bg-1 px-2 py-1 rounded">
                <pre>{{ change.new | json }}</pre>
              </div>
            }
          </div>
        </div>
      }
    } @else {
      <div class="p-3 rounded-md theme-bg-2 shadow-md">
        This activity has no changes.
      </div>
    }
  </div>
</ng-template>
